export enum EvaluationStatus {
  Upcoming = 'upcoming',
  Ongoing = 'ongoing',
  Closed = 'closed',
}
